import { MRT_RowData, MRT_Table, MRT_TableOptions, useMantineReactTable } from "mantine-react-table"
import { useNavigate } from "react-router"

export interface StaticTableProps<TData extends MRT_RowData> extends Partial<MRT_TableOptions<TData>> {
  onClickRow?: (row: MRT_RowData, runDefault: () => void) => void
  routePath?: string
}

function StaticTable<T extends MRT_RowData>({ onClickRow, routePath, ...props }: StaticTableProps<T>) {
  "use no memo"

  const navigate = useNavigate()

  const table = useMantineReactTable({
    enableColumnActions: false,
    enableColumnFilters: false,
    enablePagination: false,
    enableSorting: true,
    enableRowActions: true,
    memoMode: "rows",
    displayColumnDefOptions: {
      "mrt-row-actions": {
        header: "",
      },
    },
    // mantineSearchTextInputProps: {
    //   placeholder: "Search Employees",
    // },
    initialState: {
      density: "md",
      columnPinning: {
        right: ["mrt-row-actions"],
      },
      sorting: [
        {
          desc: false,
          id: "name",
        },
      ],
    },
    icons: {
      IconSortAscending: () => <IconMaterialSymbolsFitbitArrowUpward className="size-6 text-fg" />,
      IconSortDescending: () => <IconMaterialSymbolsFitbitArrowDownward className="size-6 text-fg" />,
    },
    mantineTableProps: {
      className: "border-none [&_thead]:!sticky [&_thead]:top-[51px]",
      highlightOnHover: true,
      withColumnBorders: false,
      withRowBorders: true,
      withTableBorder: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: (event) => {
        const runDefault = () => {
          navigate(`${routePath}/${row.original.id}`)
        }

        if (onClickRow) {
          onClickRow(row.original, runDefault)
          return
        }
        runDefault()
      },
      className: "!cursor-pointer",
    }),
    ...(props as MRT_TableOptions<T>),
  })

  return <MRT_Table table={table} />
}

export default StaticTable
